import React from "react";
import { motion } from "framer-motion";
import {
  FaFacebookF,
  FaWhatsapp,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa"; // ✅ استخدمنا fa وليس fa6

const Footer = () => {
  return (
    <footer
      style={{
        background: "linear-gradient(180deg, #0f1a0e, #1a1a1a)",
        color: "#fff",
        padding: "70px 0 25px",
        fontFamily: "Cairo, sans-serif",
        direction: "rtl",
      }}
    >
      <div
        className="container"
        style={{
          width: "90%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "40px",
            marginBottom: "50px",
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3
              style={{
                color: "#9fd87a",
                marginBottom: "20px",
                fontSize: "1.3rem",
                fontWeight: 700,
              }}
            >
              مكتب محمد إبراهيم أبو عدبة
            </h3>
            <p style={{ lineHeight: "1.9", color: "#ccc", fontSize: "15px" }}>
              مكتب محاماة متخصص في القضايا المدنية والجنائية والإدارية
              والتأمينات والمعاشات. نلتزم بتقديم استشارات دقيقة وتمثيل قانوني
              احترافي لتحقيق العدالة.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3
              style={{
                color: "#9fd87a",
                marginBottom: "20px",
                fontSize: "1.3rem",
                fontWeight: 700,
              }}
            >
              روابط سريعة
            </h3>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
              {[
                { title: "من نحن", link: "about" },
                { title: "التخصصات", link: "kind" },
                { title: "استشارات قانونية", link: "appointment" },
                { title: "تواصل معنا", link: "contact" },
              ].map((item, i) => (
                <li key={i}>
                  <a
                    href={item.link}
                    style={{
                      color: "#ccc",
                      textDecoration: "none",
                      display: "inline-block",
                      padding: "2px 0",
                      transition: "0.3s",
                    }}
                    onMouseOver={(e) => (e.target.style.color = "#9fd87a")}
                    onMouseOut={(e) => (e.target.style.color = "#ccc")}
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h3
              style={{
                color: "#9fd87a",
                marginBottom: "20px",
                fontSize: "1.3rem",
                fontWeight: 700,
              }}
            >
              تواصل معنا
            </h3>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                lineHeight: "2",
                color: "#ccc",
                fontSize: "15px",
              }}
            >
              <li
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <FaPhoneAlt color="#9fd87a" /> 01113318804
              </li>
              <li
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <FaEnvelope color="#9fd87a" /> info@mohamedadba.com
              </li>
              <li
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <FaMapMarkerAlt color="#9fd87a" /> 8 عمارات أول مايو - مدينة نصر
                - القاهرة
              </li>
            </ul>

            {/* أيقونات السوشيال */}
            <div
              style={{
                display: "flex",
                gap: "12px",
                marginTop: "22px",
              }}
            >
              <motion.a
                href="https://www.facebook.com/mohamedibrahimadba/"
                target="_blank"
                rel="noreferrer"
                whileHover={{ scale: 1.1 }}
                style={{
                  background: "#29521e",
                  padding: "10px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaFacebookF color="#fff" />
              </motion.a>

              <motion.a
                href="https://wa.me/201113318804"
                target="_blank"
                rel="noreferrer"
                whileHover={{ scale: 1.1 }}
                style={{
                  background: "#25d366",
                  padding: "10px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FaWhatsapp color="#fff" />
              </motion.a>
            </div>
          </motion.div>
        </div>

        {/* ✅ الخط السفلي */}
        <div
          style={{
            borderTop: "1px solid rgba(255,255,255,0.1)",
            paddingTop: "15px",
            textAlign: "center",
            color: "#aaa",
            fontSize: "14px",
            letterSpacing: "0.3px",
          }}
        >
          © {new Date().getFullYear()} جميع الحقوق محفوظة مكتب محمد إبراهيم أبو
          عدبة للمحاماة والاستشارات القانونية |{" "}
          <span style={{ color: "#9fd87a" }}>
            <a href="https://www.facebook.com/profile.php?id=61578318680157#">
              Horizonya
            </a>{" "}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
